var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _path19, _path20, _g, _g2, _ellipse, _path21, _path22, _ellipse2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 187,
    viewBox: "0 0 219 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 29.88,
    x2: 62.88,
    y2: 14,
    stroke: "#EBEBEB",
    strokeWidth: 1.58385,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.791923,
    y1: -0.791923,
    x2: 23.2496,
    y2: -0.791923,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 64 30.9999)",
    stroke: "#EBEBEB",
    strokeWidth: 1.58385,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 154.407,
    x2: 15.4071,
    y2: 146,
    stroke: "#EBEBEB",
    strokeWidth: 0.838511,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.419255,
    y1: -0.419255,
    x2: 12.3087,
    y2: -0.419255,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16 155)",
    stroke: "#EBEBEB",
    strokeWidth: 0.838511,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 92.1435,
    x2: 19.1435,
    y2: 80,
    stroke: "#EBEBEB",
    strokeWidth: 1.21118,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.605588,
    y1: -0.605588,
    x2: 17.7791,
    y2: -0.605588,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 20 92.9999)",
    stroke: "#EBEBEB",
    strokeWidth: 1.21118,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 120.677,
    x2: 177.676,
    y2: 109,
    stroke: "#EBEBEB",
    strokeWidth: 1.16459,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.582296,
    y1: -0.582296,
    x2: 17.0953,
    y2: -0.582296,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 178.5 121.5)",
    stroke: "#EBEBEB",
    strokeWidth: 1.16459,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 13.2753,
    x2: 176.275,
    y2: 3.00006,
    stroke: "#EBEBEB",
    strokeWidth: 1.02484,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0.512421,
    y1: -0.512421,
    x2: 15.0438,
    y2: -0.512421,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 177 14)",
    stroke: "#EBEBEB",
    strokeWidth: 1.02484,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0399 101.719C53.2791 101.965 54.0423 103.401 53.5418 104.545C52.9969 105.79 51.2849 105.701 50.0601 105.083C48.6269 104.359 48.3641 102.801 48.6947 101.248C48.9499 100.049 49.4085 99.2025 50.538 98.6916C51.7889 98.1259 52.8427 98.1784 54.1562 98.6916C55.6817 99.2877 56.3471 100.364 57.0235 101.719C57.7648 103.204 57.8133 104.496 57.0235 105.957C56.2482 107.392 53.7466 108.58 53.7466 108.58C53.7466 108.58 50.4383 109.344 48.6947 108.58C46.8225 107.76 45.5543 104.545 45.5543 104.545C45.5543 104.545 44.9212 102.202 45.0082 100.643C45.0782 99.3886 45.2457 98.6282 45.8957 97.548C46.6467 96.3 47.4054 95.7595 48.6947 95.0588C50.0256 94.3355 50.9393 94.2183 52.4495 94.0497C53.5622 93.9255 54.0197 94.0496 54.9072 94.251C56.0677 94.6317 56.8254 94.9445 57.6379 95.7983C58.544 96.7503 59.0694 97.5366 59.686 98.6916C60.2675 99.7807 60.5944 100.468 60.7783 101.718C60.9006 102.55 60.9831 102.929 60.9831 103.871C61.0361 105.136 60.9814 105.906 60.5735 107.101C60.0915 108.514 59.318 109.185 58.0476 109.994C57.0908 110.603 56.3964 111.048 55.3168 111.406C54.0532 111.824 52.0399 111.945 52.0399 111.945C52.0399 111.945 50.3681 112.069 49.3092 111.945C47.9346 111.783 45.8957 111.003 45.8957 111.003",
    stroke: "#EBEBEB",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.975 140.423C90.6747 140.564 91.1056 141.386 90.823 142.042C90.5153 142.755 89.5487 142.705 88.8571 142.35C88.0479 141.935 87.8995 141.043 88.0862 140.153C88.2302 139.466 88.4892 138.981 89.1269 138.688C89.8332 138.364 90.4282 138.394 91.1699 138.688C92.0313 139.03 92.4069 139.646 92.7889 140.423C93.2075 141.274 93.2348 142.014 92.7889 142.851C92.3511 143.673 90.9386 144.354 90.9386 144.354C90.9386 144.354 89.0706 144.792 88.0862 144.354C87.0291 143.884 86.313 142.042 86.313 142.042C86.313 142.042 85.9555 140.699 86.0046 139.806C86.0441 139.088 86.1387 138.652 86.5057 138.033C86.9298 137.318 87.3582 137.008 88.0862 136.607C88.8376 136.192 89.3535 136.125 90.2063 136.028C90.8345 135.957 91.0928 136.028 91.5939 136.144C92.2492 136.362 92.677 136.541 93.1358 137.03C93.6474 137.576 93.944 138.026 94.2922 138.688C94.6205 139.312 94.8051 139.706 94.909 140.423C94.978 140.899 95.0246 141.116 95.0246 141.656C95.0545 142.381 95.0236 142.822 94.7933 143.507C94.5212 144.316 94.0844 144.701 93.3671 145.164C92.8269 145.513 92.4348 145.768 91.8252 145.973C91.1117 146.213 89.975 146.282 89.975 146.282C89.975 146.282 89.031 146.353 88.4331 146.282C87.657 146.189 86.5057 145.742 86.5057 145.742",
    stroke: "#EBEBEB",
    strokeWidth: 0.638346,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.975 5.42283C17.6747 5.56369 18.1056 6.3864 17.823 7.0418C17.5153 7.7554 16.5487 7.70466 15.8571 7.35017C15.0479 6.93538 14.8995 6.04297 15.0862 5.153C15.2302 4.46622 15.4892 3.98092 16.1269 3.68822C16.8332 3.36407 17.4282 3.39416 18.1699 3.68822C19.0313 4.02975 19.4069 4.64626 19.7889 5.42283C20.2075 6.27384 20.2348 7.01428 19.7889 7.85128C19.3511 8.67307 17.9386 9.35429 17.9386 9.35429C17.9386 9.35429 16.0706 9.79194 15.0862 9.35429C14.0291 8.88434 13.313 7.0418 13.313 7.0418C13.313 7.0418 12.9555 5.6995 13.0046 4.80608C13.0441 4.08758 13.1387 3.65186 13.5057 3.03292C13.9298 2.31784 14.3582 2.00817 15.0862 1.60668C15.8376 1.19225 16.3535 1.1251 17.2063 1.02848C17.8345 0.957296 18.0928 1.02842 18.5939 1.14382C19.2492 1.36197 19.677 1.54118 20.1358 2.03038C20.6474 2.57586 20.944 3.02638 21.2922 3.68822C21.6205 4.31223 21.8051 4.70586 21.909 5.42251C21.978 5.89912 22.0246 6.11635 22.0246 6.65601C22.0545 7.38059 22.0236 7.82169 21.7933 8.50658C21.5212 9.316 21.0844 9.7008 20.3671 10.1641C19.8269 10.513 19.4348 10.7684 18.8252 10.9733C18.1117 11.213 16.975 11.282 16.975 11.282C16.975 11.282 16.031 11.3533 15.4331 11.282C14.657 11.1894 13.5057 10.7423 13.5057 10.7423",
    stroke: "#EBEBEB",
    strokeWidth: 0.638346,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.937 38.719C189.159 38.9648 189.911 40.4007 189.417 41.5445C188.88 42.7899 187.193 42.7014 185.986 42.0827C184.574 41.3588 184.315 39.8013 184.641 38.2481C184.892 37.0495 185.344 36.2025 186.457 35.6916C187.69 35.1259 188.728 35.1784 190.023 35.6916C191.526 36.2877 192.182 37.3637 192.848 38.719C193.579 40.2042 193.627 41.4965 192.848 42.9573C192.084 44.3915 189.619 45.5804 189.619 45.5804C189.619 45.5804 186.359 46.3442 184.641 45.5804C182.796 44.7602 181.546 41.5445 181.546 41.5445C181.546 41.5445 180.922 39.2018 181.008 37.6426C181.077 36.3886 181.242 35.6282 181.883 34.548C182.623 33.3 183.37 32.7595 184.641 32.0588C185.952 31.3355 186.853 31.2183 188.341 31.0497C189.437 30.9255 189.888 31.0496 190.763 31.251C191.907 31.6317 192.653 31.9445 193.454 32.7983C194.347 33.7503 194.864 34.5366 195.472 35.6916C196.045 36.7807 196.367 37.4677 196.548 38.7184C196.669 39.5502 196.75 39.9294 196.75 40.8712C196.802 42.1358 196.749 42.9056 196.347 44.1009C195.872 45.5136 195.109 46.1852 193.858 46.9937C192.915 47.6027 192.23 48.0484 191.166 48.4059C189.921 48.8244 187.937 48.9447 187.937 48.9447C187.937 48.9447 186.29 49.0691 185.246 48.9447C183.892 48.7832 181.883 48.0029 181.883 48.0029",
    stroke: "#EBEBEB",
    strokeWidth: 1.11408,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.937 153.719C202.159 153.965 202.911 155.401 202.417 156.545C201.88 157.79 200.193 157.701 198.986 157.083C197.574 156.359 197.315 154.801 197.641 153.248C197.892 152.049 198.344 151.202 199.457 150.692C200.69 150.126 201.728 150.178 203.023 150.692C204.526 151.288 205.182 152.364 205.848 153.719C206.579 155.204 206.627 156.496 205.848 157.957C205.084 159.392 202.619 160.58 202.619 160.58C202.619 160.58 199.359 161.344 197.641 160.58C195.796 159.76 194.546 156.545 194.546 156.545C194.546 156.545 193.922 154.202 194.008 152.643C194.077 151.389 194.242 150.628 194.883 149.548C195.623 148.3 196.37 147.76 197.641 147.059C198.952 146.336 199.853 146.218 201.341 146.05C202.437 145.925 202.888 146.05 203.763 146.251C204.907 146.632 205.653 146.944 206.454 147.798C207.347 148.75 207.864 149.537 208.472 150.692C209.045 151.781 209.367 152.468 209.548 153.718C209.669 154.55 209.75 154.929 209.75 155.871C209.802 157.136 209.749 157.906 209.347 159.101C208.872 160.514 208.109 161.185 206.858 161.994C205.915 162.603 205.23 163.048 204.166 163.406C202.921 163.824 200.937 163.945 200.937 163.945C200.937 163.945 199.29 164.069 198.246 163.945C196.892 163.783 194.883 163.003 194.883 163.003",
    stroke: "#EBEBEB",
    strokeWidth: 1.11408,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.149 115.199H96.7557V142.781C96.7557 151.728 89.5031 158.98 80.5567 158.98H74.8655C71.2386 158.98 68.2983 161.92 68.2983 165.547V175.76L150.606 176.055V165.547C150.606 161.92 147.666 158.98 144.039 158.98H138.348C129.401 158.98 122.149 151.728 122.149 142.781V115.199Z",
    fill: "url(#paint0_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.149 115.199H96.7557V142.781C96.7557 151.728 89.5031 158.98 80.5567 158.98H74.8655C71.2386 158.98 68.2983 161.92 68.2983 165.547V175.76L150.606 176.055V165.547C150.606 161.92 147.666 158.98 144.039 158.98H138.348C129.401 158.98 122.149 151.728 122.149 142.781V115.199Z",
    fill: "url(#paint1_diamond)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4726 73.4192V42.5224H84.873V73.4192C84.873 83.1947 76.9483 91.1194 67.1728 91.1194C57.3972 91.1194 49.4726 83.1947 49.4726 73.4192Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 5.25373
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4726 73.4192V42.5224H84.873V73.4192C84.873 83.1947 76.9483 91.1194 67.1728 91.1194C57.3972 91.1194 49.4726 83.1947 49.4726 73.4192Z",
    stroke: "url(#paint3_diamond)",
    strokeWidth: 5.25373
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.343 39.8955H169.656C170.949 39.8955 171.997 40.9438 171.997 42.2368V73.4192C171.997 84.6455 162.897 93.7463 151.67 93.7463C140.444 93.7463 131.343 84.6455 131.343 73.4192V39.8955Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.343 39.8955V34.6418H126.09V39.8955H131.343ZM131.343 45.1492H169.656V34.6418H131.343V45.1492ZM166.744 42.2368V73.4192H177.251V42.2368H166.744ZM136.597 73.4192V39.8955H126.09V73.4192H136.597ZM151.67 88.4925C143.346 88.4925 136.597 81.744 136.597 73.4192H126.09C126.09 87.5471 137.542 99 151.67 99V88.4925ZM166.744 73.4192C166.744 81.744 159.995 88.4925 151.67 88.4925V99C165.798 99 177.251 87.5471 177.251 73.4192H166.744ZM169.656 45.1492C168.048 45.1492 166.744 43.8453 166.744 42.2368H177.251C177.251 38.0422 173.851 34.6418 169.656 34.6418V45.1492Z",
    fill: "url(#paint4_linear)",
    mask: "url(#path-18-inside-1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.343 39.8955V34.6418H126.09V39.8955H131.343ZM131.343 45.1492H169.656V34.6418H131.343V45.1492ZM166.744 42.2368V73.4192H177.251V42.2368H166.744ZM136.597 73.4192V39.8955H126.09V73.4192H136.597ZM151.67 88.4925C143.346 88.4925 136.597 81.744 136.597 73.4192H126.09C126.09 87.5471 137.542 99 151.67 99V88.4925ZM166.744 73.4192C166.744 81.744 159.995 88.4925 151.67 88.4925V99C165.798 99 177.251 87.5471 177.251 73.4192H166.744ZM169.656 45.1492C168.048 45.1492 166.744 43.8453 166.744 42.2368H177.251C177.251 38.0422 173.851 34.6418 169.656 34.6418V45.1492Z",
    fill: "url(#paint5_diamond)",
    mask: "url(#path-18-inside-1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4229 19.7562H151.483V88.4925C151.483 111.705 132.665 130.522 109.453 130.522C86.2403 130.522 67.4229 111.705 67.4229 88.4925V19.7562Z",
    fill: "url(#paint6_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4229 19.7562H151.483V88.4925C151.483 111.705 132.665 130.522 109.453 130.522C86.2403 130.522 67.4229 111.705 67.4229 88.4925V19.7562Z",
    fill: "url(#paint7_diamond)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4229 19.7562H151.483V88.4925C151.483 111.705 132.665 130.522 109.453 130.522C86.2403 130.522 67.4229 111.705 67.4229 88.4925V19.7562Z",
    fill: "url(#paint8_linear)",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.483 19.7562H67.4229V88.4925C67.4229 111.705 86.2403 130.522 109.453 130.522C126.533 130.522 141.234 120.334 147.809 105.703C142.63 115.269 132.506 121.767 120.864 121.767C91.833 121.767 68.2985 98.232 68.2985 69.2007V19.7566H151.483L151.483 19.7562Z",
    fill: "url(#paint9_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.483 19.7562H67.4229V88.4925C67.4229 111.705 86.2403 130.522 109.453 130.522C126.533 130.522 141.234 120.334 147.809 105.703C142.63 115.269 132.506 121.767 120.864 121.767C91.833 121.767 68.2985 98.232 68.2985 69.2007V19.7566H151.483L151.483 19.7562Z",
    fill: "url(#paint10_diamond)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.483 19.7562H67.4229V88.4925C67.4229 111.705 86.2403 130.522 109.453 130.522C126.533 130.522 141.234 120.334 147.809 105.703C142.63 115.269 132.506 121.767 120.864 121.767C91.833 121.767 68.2985 98.232 68.2985 69.2007V19.7566H151.483L151.483 19.7562Z",
    fill: "white",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6266,
    cy: 53.2483,
    r: 4.37811,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.716,
    cy: 53.2483,
    r: 4.37811,
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6022 43.3984C99.6022 43.3984 93.8749 48.1141 89.0948 49.5278C85.6536 50.5455 80.1196 51.4979 80.1196 51.4979",
    stroke: "black",
    strokeWidth: 3.50249,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.742 43.3976C119.742 43.3976 125.469 48.1133 130.249 49.5269C133.69 50.5446 139.224 51.4971 139.224 51.4971",
    stroke: "black",
    strokeWidth: 3.50249,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.286 93.2604C105.286 93.2604 113.374 90.1448 118.676 89.2642C124.046 88.3722 132.49 88.708 132.49 88.708",
    stroke: "black",
    strokeWidth: 3.06468,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.189,
    cy: 69.8856,
    rx: 7.66169,
    ry: 3.28358,
    fill: "url(#paint11_linear)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.3433,
    cy: 69.8856,
    rx: 7.66169,
    ry: 3.28358,
    fill: "url(#paint12_linear)",
    fillOpacity: 0.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.7895,
    cy: 30.791,
    rx: 6.26497,
    ry: 2.38666,
    transform: "rotate(-26.1773 79.7895 30.791)",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.925 33.4051C158.925 39.5709 153.927 44.5693 147.761 44.5693C141.595 44.5693 136.597 39.5709 136.597 33.4051C136.597 27.2393 147.761 11 147.761 11C147.761 11 158.925 27.2393 158.925 33.4051Z",
    fill: "#0CABDD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.63 34.5439C156.63 40.0805 152.145 44.5688 146.613 44.5688C141.081 44.5688 136.597 40.0805 136.597 34.5439C136.597 29.0072 146.613 14.1297 146.613 14.1297C146.613 14.1297 156.63 29.0072 156.63 34.5439Z",
    fill: "#8DC7D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.292,
    cy: 34.3437,
    rx: 3.75617,
    ry: 1.98242,
    transform: "rotate(-90 141.292 34.3437)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 176.055,
    width: 218.905,
    height: 10.9453,
    rx: 5.47264,
    fill: "url(#paint13_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: 117.771,
    y: 57.8458,
    width: 32.8358,
    height: 24.0796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4.37811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b",
    x: 70.9254,
    y: 57.8458,
    width: 32.8358,
    height: 24.0796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4.37811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 121.711,
    y1: 140.373,
    x2: 101.548,
    y2: 199.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAB47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.2983 126.023) rotate(16.5216) scale(85.8527 42.9913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 87.4998,
    y1: 39.8955,
    x2: 55.9315,
    y2: 88.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAB47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8457 49.4737) rotate(27.9868) scale(46.038 35.0405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 171.997,
    y1: 39.8955,
    x2: 140.429,
    y2: 88.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAB47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.343 49.4737) rotate(27.9868) scale(46.038 35.0405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 151.483,
    y1: 19.7562,
    x2: 86.6865,
    y2: 119.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAB47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4229 39.4577) rotate(27.863) scale(95.0829 72.1577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 151.483,
    y1: 98.3433,
    x2: 67.4229,
    y2: 19.7562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 155.323,
    y1: 19.7562,
    x2: 91.7468,
    y2: 122.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAB47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4229 39.4577) rotate(26.8189) scale(98.4943 72.8409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B734",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 128.899,
    y1: 61.2075,
    x2: 140.527,
    y2: 72.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 82.0531,
    y1: 61.2075,
    x2: 93.6817,
    y2: 72.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 60.199,
    y1: 149.567,
    x2: 232.478,
    y2: 253.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowScore);
export default __webpack_public_path__ + "static/media/low-score.13ddc81e.svg";
export { ForwardRef as ReactComponent };